export const CONFIG_TYPE = 0
export const FRONT_TYPE = 1
export const APP_TYPE = 2
